if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false;
      }

      // Ensure aria-expanded is only present on mobile/tablet for accessibility
      this.updateAriaForViewport();
      this.setupMobileAccessibility();

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
        this.updateAriaForViewport();
        this.setupMobileAccessibility();
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
        this.updateAriaForViewport();
        this.setupMobileAccessibility();
      });
    }

    // Setup mobile accessibility for TalkBack
    setupMobileAccessibility() {
      if (this.summaryElement) {
        if (FoxTheme.config.mqlTablet) {
          // On mobile/tablet: Add button role and aria-expanded for TalkBack
          this.summaryElement.setAttribute('role', 'button');
          this.summaryElement.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');
          this.summaryElement.removeAttribute('tabindex');
        } else {
          // On desktop: Remove button role and aria-expanded
          this.summaryElement.setAttribute('role', 'heading');
          this.summaryElement.removeAttribute('aria-expanded');
          this.summaryElement.setAttribute('tabindex', '-1');
        }
      }
    }

    // Keep aria-expanded off on desktop, reflect state on mobile/tablet
    updateAriaForViewport() {
      if (FoxTheme.config.mqlTablet) {
        // this.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');
        if (this.summaryElement) {
          this.summaryElement.removeAttribute('tabindex');
          this.summaryElement.removeAttribute('aria-level');
        }
      } else {
        this.removeAttribute('aria-expanded');
        if (this.summaryElement) {
          this.summaryElement.setAttribute('tabindex', '-1');
        }
      }
    }

    handleAfterToggle() {
      this.updateAriaForViewport();
      this.setupMobileAccessibility();
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}